<template>
  <div class="white-card session time-off">
    <div class="session-details white-card-header">

      <h4 class="session-name">
        {{ entry.time }}
      </h4>
      <div
        v-if="!member.deleted && entry.can_manage_entry"
        class="session-control-buttons"
      >
        <button
          class="edit-session"
          @click="editEntry(entry)"
        >
          <i class="atto atto-edit-btn" />
          {{label.get('edit')}}
        </button>
        <button
          class="delete-session"
          @click="deleteEntry(entry)"
        >
          <i class="atto atto-delete" />
          {{ label.get('delete') }}
        </button>
      </div>
    </div>
    <div class="session-wrap">
      <div class="status detailed-status">
        <div
          class="hour-logs pto"
        >
          <i class="atto atto-pto" />
          <div class="log-description">
            <h4>{{ entry.code.title }}</h4>
            <p>{{ entry.code.name }}</p>
          </div>
        </div>
        <div class="notes-wrapper pto">
          <i class="atto atto-notes-lt" />
          <div class="notes">
            <h4 v-if="!member.deleted && entry.can_edit_member_note" @click="editNote(0)">
              {{ label.get('member_notes') }}
              <i class="atto atto-edit-btn"/>
            </h4>
            <h4 v-if="!entry.can_edit_member_note">
              {{ label.get('member_notes') }}
            </h4>
            <p v-if="entry.member_note">
              {{ entry.member_note }}
            </p>
            <p v-else-if="!member.deleted && !entry.member_note && entry.can_edit_member_note && member.id === this.$store.state.user.id">
              {{ label.get('type_your_notes_here') }}
            </p>
            <p v-else>
              {{ label.get('the_team_member_hasnt_added_any_notes') }}
            </p>
          </div>
        </div>
        <div class="notes-wrapper admin-note-wrapper pto">
          <i class="atto atto-notes-lt" />
          <div class="notes">
            <h4 v-if="!member.deleted && entry.can_edit_admin_note" @click="editNote(1)" class="edit-note">
              {{ entry.admin_note ? label.get('admin_notes') : label.get('add_admin_notes') }}
              <i v-if="!entry.admin_note" class="atto atto-add-more"/>
              <i v-if="entry.admin_note" class="atto atto-edit-btn"/>
            </h4>
            <h4 v-if="!entry.can_edit_admin_note">
              {{ label.get('admin_notes') }}
            </h4>
            <p v-if="entry.admin_note">
              {{ entry.admin_note }}
            </p>
            <p v-else-if="!entry.admin_note && !entry.can_edit_admin_note">
              {{ label.get('the_admin_hasnt_added_any_notes') }}
            </p>
            <!-- <p v-else-if="!entry.note && entry.user_id === this.$store.state.user.id">
               {{ label.get('type_your_notes_here') }}
             </p>-->
           <!-- <p v-else-if="!entry.note && entry.user_id !== this.$store.state.user.id">
              {{ label.get('the_team_member_hasnt_added_any_notes') }}
            </p>-->
            <!--<i class="atto atto-currly-lines" />-->
          </div>
        </div>

      </div>
    </div>
    <edit-notes-component
        v-if="showEditNote"
        :note="note"
        @onClose="onNoteClose"
    />
  </div>
</template>

<script>
    import ManualEntryComponent from '../ManualEntryComponent';
    import EditNotesComponent from "./EditNotesComponent";
    import TimesheetService from '../TimesheetService';

    export default {
        name: "TimeOffEntryComponent",
        components: {
          ManualEntryComponent,
          EditNotesComponent
        },
        props: {
            entry: {
              type: Object,
              default: () => {}
            },
            member: {
              type: Object,
              default: () => {}
            }
        },
        data() {
          return {
            showEditNote: false,
            note: null
          }
        },
        computed: {
            archivedMemberCanNotEditOrDelete(){
              return this.$store.state.showArchivedMembers;
            }
        },
        methods: {
          getTypeClass(type) {
              if (type === 0) {
                  return 'clockedIn';
              } else if (type === 1) {
                  return 'clockedOut';
              } else if (type === 4) {
                  return 'breakIn';
              } else if (type === 5) {
                  return 'breakOut';
              } else {
                  return '';
              }
          },
          deleteEntry(entry){
              if(!this.$store.state.subscribed && !this.$store.state.onTrial) {
                  this.$root.$emit('noSubscription');
                  return;
              }

              this.$root.$emit("onDeleteEntry", entry);
          },
          editEntry(entry){
              if(!this.$store.state.subscribed && !this.$store.state.onTrial) {
                  this.$root.$emit('noSubscription');
                  return;
              }

              this.$store.commit('showLoading');
              TimesheetService.getTimeEntryForEdit(entry.id).then((data) => {
                  this.$store.commit('hideLoading');
                  this.$root.$emit('showEditEntry', { member: this.member, entry: data });
              }).catch((error) => {
                debugger;
              });
          },
          editNote(type = 0){
            this.note = {
              timesheet_id: this.entry.id,
              type: type,
              text: type === 0 ? this.entry.member_note : this.entry.admin_note
            };
            this.showEditNote = true;
          },
          onNoteClose(note) {
            this.showEditNote = false;
            if(note) {
              if(note.type === 1) {
                this.entry.admin_note = note.text;
              } else {
                this.entry.member_note = note.text;
              }
            }
            this.note = null;
          }
        }
    }
</script>
<style lang="scss" scoped>

  .white-card {
    &.time-off{
      .session-wrap{
        padding: 0;
      }
    }
  }


    .session {
      height: auto;
    }
    .detailed-status {
        padding: 17px 58px 71px 20px !important;
        width: 100% !important;
        margin: 0 !important;

        .hour-logs {
          padding: 0 0 40px;

            ul {
                display: flex;
                flex-direction: column;
                margin-bottom: 20px;

                li {
                    display: inline-flex;
                    flex-direction: row;
                    align-items: flex-start;
                    padding-bottom: 40px;

                    .hour {
                        width: 80px;
                        margin-right: 38px;
                        font-family: $roboto-font;
                        font-weight: $roboto-medium;
                        font-size: 0.875rem;
                        line-height: 1.5rem;
                        color: $atto-not-active;
                    }

                    .path {
                        display: flex;
                        min-height: 24px;
                        width: 24px;
                        margin-right: 58px;
                        position: relative;
                        flex-direction: column;
                        justify-content: center;

                        i.dot-connect {
                            display: inline-flex;
                            align-self: center;
                            width: 8px;
                            height: 8px;
                            background-color: $atto-dark-grey;
                            border-radius: 8px;
                            position: relative;
                            z-index: 2;
                        }

                        i.clocked-in-pin,
                        i.clocked-out-pin{
                            width: 24px;
                            height: 24px;
                            z-index: 2;
                            display: block;
                            align-self: center;
                            position: relative;
                            margin-top: 0px;
                            -webkit-background-size: contain;
                            background-size: contain;
                            background-position: center;
                        }

                        i.clocked-in-pin{
                            background-image: url('~@assets/images/clock-in-pin.svg');
                        }

                        i.clocked-out-pin{
                            background-image: url('~@assets/images/clock-out-pin.svg');
                        }

                        .connect-line {
                            position: absolute;
                            width: 2px;
                            bottom: 16px;
                            top: auto;
                            left: 50%;
                            margin-left: -1px;
                            height: 57px;
                            background-color: $atto-light-grey;
                            z-index: 1;
                        }
                    }

                    .log-description {
                        min-width: 320px;
                        width: 44.44%;
                        position: relative;

                        h4 {
                            color: $atto-font-color;
                            font-family: $roboto-font;
                            font-weight: $roboto-regular;
                            font-size: 0.9375rem;
                            line-height: 1.5rem;
                        }

                        span {
                            font-family: $roboto-font;
                            font-weight: 400;
                            font-size: 0.875rem;
                            line-height: 1.25rem;
                            color: $atto-not-active;
                        }

                        .manual-entry{
                            font-size: 16px;
                            position: absolute;
                            left: -22px;
                            top: 4px;
                            cursor: pointer;
                          &:focus{
                            outline: none;
                          }
                        }
                    }

                    &.clockedIn{
                        min-height: 84px;
                    }
                    &.clockedIn,
                    &.clockedOut {
                        padding-bottom: 20px;
                        /*height: 112px;*/
                        .path {
                            .connect-line {
                                height: 81px;
                            }
                        }

                        .hour {
                            font-size: 1rem;
                            color: $atto-font-color;
                        }

                        .log-description {
                            h4 {
                                font-size: 1rem;
                                font-family: $roboto-font;
                                font-weight: $roboto-medium;
                            }
                        }
                    }

                    &.clockedIn {
                        .path {
                            .dot-connect {
                                background-color: $atto-green;
                            }

                            .connect-line {
                                display: none;
                            }
                        }
                    }

                    &.clockedOut {
                        .path {
                            .dot-connect {
                                background-color: $atto-red;
                            }

                            .connect-line {
                                height: 56px;
                            }
                        }
                    }

                    &:nth-child(2),
                    &.breakIn:nth-child(2),
                    &.clockedOut:nth-child(2) {
                        .path {
                            .connect-line {
                                height: 85px;
                            }
                            .connect-line.dotted{
                                background-position: center 0px;
                                height: 67px;
                            }
                        }
                    }

                    &.breakIn {
                        .path {
                            i.dot-connect {
                                background-color: $atto-orange;
                            }

                            span.connect-line {
                                background-color: $atto-light-grey;
                            }
                        }
                    }

                    &.breakOut {
                        .path {
                            i.dot-connect {
                                background-color: $atto-orange;
                            }


                            span.connect-line {
                                background-color: $atto-orange;
                            }
                        }
                    }

                    &.onTheClock{
                        .path{
                            .dot-connect{
                                background-color: $atto-light-green;
                            }
                        }

                        .connect-line.dotted{
                            background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAGCAYAAADpJ08yAAAAGElEQVQYV2NkgALG9+/f/wexsTDgamAMAH5QC2tK+9KcAAAAAElFTkSuQmCC) center 0px;
                            background-repeat: repeat-y;
                        }

                        .log-description{
                            h4{
                                font-weight: 500;
                                font-size: 1rem;
                            }
                        }
                    }

                  &.auto-break {
                    padding-top: 37px;

                    .log-description{
                      margin-top: 3px;
                      h4{
                        font-weight: 500;
                        font-size: 1rem;
                      }
                    }

                    .atto-break {
                      text-align: center;
                      &:before {
                        font-size: 20px;
                        color: #c7c7c7;
                      }
                    }
                  }
                }
            }

            &:after {
                content: '';
                display: flex;
                width: 66px;
                height: 2px;
                background-color: $atto-light-grey;
                margin-left: 200px;
            }
            &.pto{
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                i.atto-pto{
                  font-size: 18px;
                  margin-right: 20px;
                  width: 24px;
                  height: 24px;
                  display: flex;
                  align-items: center;
                  justify-content: center;;
                    &:before{
                        color: $atto-green;
                    }
                }

                p{
                    font-family: $roboto-font;
                    font-weight: 400;
                    color: $atto-not-active;
                    font-size: 0.875rem;
                    line-height: 1.5rem;
                }

                padding-left: 0px!important;

                &:after{
                    content: none;
                }
            }

          .log-description{
            h4{
              display: flex;
              flex-direction: row;
              align-items: center;
              color: #666666;
              font: $roboto-regular 0.75rem/1.5rem $roboto-font;
              letter-spacing: 0.5px;
            }
            p{
              margin: 0;
              font: $roboto-regular 0.9375rem/1.25rem $roboto-font;
              color: #666666;
            }
          }
        }

        .notes-wrapper {
            display: flex;
            flex-direction: row;

            > i.atto-notes-lt {
                font-size: 18px;
                width: 24px;
                height: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 0 20px 0 0;
            }

            .notes {
              max-width: 320px;
                h4 {
                    font-size: 0.9375rem;
                    line-height: 1.5rem;
                    color: $atto-font-color;
                    font-family: $roboto-font;
                    font-weight: $roboto-regular;
                    margin-bottom: 4px;

                  &.edit-note{
                    cursor: pointer;
                  }

                  i.atto-edit-btn{
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 14px;
                    width: 20px;
                    height: 20px;
                    margin-left: 8px;
                  }
                  &:hover{
                    i.atto-edit-btn{
                      &::before{
                        color: #262626;
                      }
                    }
                  }
                }

                p {
                    font-size: 0.875rem;
                    line-height: 1.25;
                    font-family: $roboto-font;
                    font-weight: $roboto-regular;
                    color: #666666;
                    margin-bottom: 20px;
                    /*display: inline-block;*/

                    &:last-child {
                        margin-bottom: 0;
                    }
                }



                i.atto-currly-lines {
                    display: inline-flex;
                    font-size: 66px;
                    color: $atto-not-active;
                    margin-top: 0;
                    margin-right: 0;
                    line-height: 40px;
                }

                &::after{
                    content: none;
                }

            }
            &.pto{
                padding-left: 0px!important;
            }
        }
        .admin-note-wrapper{
          margin-top: 40px;
          .atto-add-more{
            font-size: 10px;
            margin-left: 11px;
            position: relative;
            top: -1px;
          }
        }
    }
    .session-control-buttons{
      border-left: 1px solid #E3E3E3;
      padding-left: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      button{
        font: $roboto-medium 0.8125rem/0.9375rem $roboto-font;
        color: $atto-font-color;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: transparent;
        cursor: pointer;
        @include base-transition(ease all 0.1s);
        i.atto{
          width: 24px;
          height: 24px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin-right: 3px;
          @include base-transition(ease all 0.1s);

          &:before{
            color: $atto-font-color;
          }
        }
        &:hover{
          background-color: transparent;
          color: $atto-font-color;
          i {
            background-color: #EFEFEF;
            border-radius: 100%;
          }
        }
      }
    }
</style>